import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

export interface LoanEligibilityResponse {
  success: boolean;
  data?: {
    eligible: boolean;
  };
}

@Injectable()
export class FinGatewayService {
    constructor(public httpClient: HttpClient) { }

    async getLoanEligibility(captainId: string, cityId: string, modeId: string): Promise<LoanEligibilityResponse> {
        const url = `${environment.server}/api/fin-gateway/loan-eligibility`;
        const result = await this.httpClient.get<LoanEligibilityResponse>(url, {
            params: { captainId, cityId, modeId }
        }).toPromise();
        return result;
    }
}
